const setTitleTag = (title: string): (() => void) => {
  const prevTitle = document.title
  document.title = title
  return () => {
    document.title = prevTitle
  }
}

export default setTitleTag
